import { LoadingConfig } from '@eng-dx-gpt/loading';

export const loadingConfig: Partial<LoadingConfig> = {
    enabled: true
};
